import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home', roles: ['superAdmin', 'projectManager'] }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: () => import('@/views/UserManagement.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user', roles: ['superAdmin'] }
      },
      {
        path: 'projects',
        name: 'ProjectManagement',
        component: () => import('@/views/ProjectManagement.vue'),
        meta: { title: '项目管理', icon: 'el-icon-folder', roles: ['superAdmin', 'projectManager'] }
      },
      {
        path: 'attendance',
        name: 'AttendanceRecords',
        component: () => import('@/views/AttendanceRecords.vue'),
        meta: { title: '考勤记录', icon: 'el-icon-document', roles: ['superAdmin', 'projectManager'] }
      },
      {
        path: 'attendance-calendar',
        name: 'AttendanceCalendar',
        component: () => import('@/views/AttendanceCalendar.vue'),
        meta: { title: '考勤日历', icon: 'el-icon-date', roles: ['superAdmin', 'projectManager'] }
      },
      {
        path: 'attendance-audit',
        name: 'AttendanceAudit',
        component: () => import('@/views/AttendanceAudit.vue'),
        meta: { title: '考勤审核', icon: 'el-icon-check', roles: ['superAdmin', 'projectManager'] }
      },
      {
        path: 'attendance-analytics',
        name: 'AttendanceAnalytics',
        component: () => import('@/views/AttendanceAnalytics.vue'),
        meta: { title: '考勤分析', icon: 'el-icon-data-analysis', roles: ['superAdmin', 'projectManager'] }
      },
      {
        path: 'reports',
        name: 'ReportManagement',
        component: () => import('@/views/ReportManagement.vue'),
        meta: { title: '统计报表', icon: 'el-icon-s-order', roles: ['superAdmin', 'projectManager'] }
      },
      {
        path: 'appeals-management',
        name: 'AppealManagement',
        component: () => import('@/views/AppealManagement.vue'),
        meta: { title: '申述管理', icon: 'el-icon-message', roles: ['superAdmin', 'projectManager'] }
      },
      {
        path: 'leave-management',
        name: 'LeaveManagement',
        component: () => import('@/views/LeaveManagement.vue'),
        meta: { title: '请假管理', icon: 'el-icon-s-check', roles: ['superAdmin', 'projectManager'] }
      },
      {
        path: 'holiday-management',
        name: 'HolidayManagement',
        component: () => import('@/views/HolidayManagement.vue'),
        meta: { title: '节假日管理', icon: 'el-icon-date', roles: ['superAdmin'] }
      },
      {
        path: 'warning',
        name: 'Warning',
        component: () => import('@/views/Warning.vue'),
        meta: { title: '考勤预警', icon: 'el-icon-warning-outline', roles: ['superAdmin'] }
      },
      {
        path: 'settings',
        name: 'SystemSettings',
        component: () => import('@/views/SystemSettings.vue'),
        meta: { title: '系统配置', icon: 'el-icon-setting', roles: ['superAdmin'] }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/Profile.vue'),
        meta: { title: '个人中心', icon: 'el-icon-user' }
      },
      {
        path: 'location-test',
        name: 'LocationTest',
        component: () => import('@/views/LocationTest.vue'),
        meta: { title: '定位测试', icon: 'el-icon-location' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  const userType = store.getters.userType
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next('/login')
      return
    }
    
    // 检查角色权限
    const requiredRoles = to.meta.roles
    if (requiredRoles && requiredRoles.length > 0) {
      let hasPermission = false
      
      if (userType === 1 && requiredRoles.includes('superAdmin')) {
        hasPermission = true
      } else if (userType === 2 && requiredRoles.includes('projectManager')) {
        hasPermission = true
      }
      
      if (!hasPermission) {
         // 没有权限，重定向到首页或显示错误页面
         next('/admin/dashboard')
         return
       }
    }
    
    next()
  } else if (to.path === '/login' && isLoggedIn) {
    next('/')
  } else {
    next()
  }
})

export default router